import { useEffect, useState } from 'react';
import { normalizePhoneInput } from '../utils/formValidation';
import './PhoneInput.css';

function PhoneInput({
  id = 'phone',
  label = 'Mobile Number',
  value,
  onChange,
  required = false,
  disabled = false,
}) {
  const [countryCode, setCountryCode] = useState('91');

  useEffect(() => {
    const digits = String(value || '').replace(/\D/g, '');
    if (digits.length > 10) {
      const cc = digits.slice(0, digits.length - 10);
      const local = digits.slice(-10);
      if (cc) setCountryCode(cc);
      if (local !== digits) onChange(local);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="phone-field form-group">
      <label htmlFor={`${id}-number`}>{label}</label>
      <div className="phone-field__row">
        <span className="phone-field__plus" aria-hidden="true">
          +
        </span>
        <input
          id={`${id}-code`}
          type="tel"
          className="phone-field__code"
          value={countryCode}
          onChange={(e) =>
            setCountryCode(normalizePhoneInput(e.target.value).slice(0, 3))
          }
          inputMode="numeric"
          maxLength={3}
          disabled={disabled}
          aria-label="Country code"
        />
        <input
          id={`${id}-number`}
          name={id}
          type="tel"
          className="phone-field__number"
          value={value}
          onChange={(e) => onChange(normalizePhoneInput(e.target.value))}
          placeholder="9876543210"
          inputMode="numeric"
          maxLength={10}
          pattern="[0-9]{10}"
          required={required}
          disabled={disabled}
          aria-label="Mobile number"
        />
      </div>
      <small className="phone-field__hint">
        +{countryCode || '91'} and 10-digit mobile (edit both fields freely)
      </small>
    </div>
  );
}

export default PhoneInput;
